import React, { useEffect, useState, useRef, useContext } from 'react';
import { Link, useNavigate, useParams  } from "react-router-dom";
import Layout from '../../parts/Layout';
import helpers from '../../../services/helpers';
import { httpRequest } from '../../../services/httpService';
import Swal from 'sweetalert2';
import Loader from '../../parts/Loader';
import store from '../../../services/store';
import { InputText } from 'primereact/inputtext';
// import InputTextArea from '../../elements/InputTextArea';
import RenderErrors from '../../elements/RenderErrors';
import ContactListModal from '../../modals/ContactListModal';
import AddressBookModal from '../../modals/AddressBookModal';
import ProductFinderModal from '../../modals/ProductFinderModal';
import PaymentsListModal from '../../modals/PaymentsListModal';
import initTreeView from '../../../services/initTreeView';
// import ButtonGroup from 'react-bootstrap/ButtonGroup';
// import Button from 'react-bootstrap/Button';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputNumber } from 'primereact/inputnumber';
import { SplitButton } from 'primereact/splitbutton';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputTextarea } from 'primereact/inputtextarea';
import { InputMask } from 'primereact/inputmask';

import { getApiData, getServiceHubEnums, postApiData } from '../../../services/apiService';
import BrandFormModal from '../../modals/BrandFormModal';
import InvoiceListModal from '../../modals/InvoiceListModal';
import { serviceRequestData } from '../../../services/serviceHubStore';
import ProductUnitFormModal from './ProductUnitFormModal';
import ProductUnitListModal from './ProductUnitListModal';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ProfileContext from '../../../services/profileContext';

export default function ServiceRequestForm (){
    const { service_request_id } = useParams();
    const [loading, setLoading] = useState(1);
    const navigate = useNavigate();
    const [errors, setErrors] = useState([]);
    const [page_title, setPageTitle] = useState('New Service Request');
    const [form_data, setFormData] = useState(serviceRequestData);
    const [record_items, setRecordItems] = useState([]);
    const [table_items, setTableItems] = useState([]);
    const [enums, setEnums] = useState(store.order_enums);
    const [sub_service_types, setSubTypes] = useState(store.order_enums);
    const [product_unit_list_modal, setProductUnitListModal] = useState(0);
    const [product_unit_form_modal, setProductUnitFormModal] = useState(0);
    const [customer_modal, setContactModal] = useState(0);
    const [address_modal, setAddressModal] = useState(0);
    const [address_type, setAddressType] = useState('');
    const [same_address, setSameAddress] = useState(0);
    const [payments_modal, setPaymentsModal] = useState(false);
    const [button_items, setButtonItems] = useState([]);
    const [show_brand_modal, setShowBrandModal] = useState(0);
    const dropdownRef = useRef(null);
    const [product_unit_id, setProductUnitID] = useState(0);
    
   
    useEffect(() => {
        initTreeView()

        
        const product_unit_id = helpers.getURLParams('ProductUnit') ?? ''
        if(product_unit_id && !service_request_id){
            fetchProductUnit(product_unit_id)
        }
        else if(service_request_id){
            setPageTitle('Edit Service Request')
            fetchData(service_request_id)
        }
        else{
            setButtonItems([{
                label: 'Save and Confirm',
                icon: 'pi pi-refresh',
                command: (e) => {
                    submit(e.originalEvent, 2)
                }
            }])
            fetchEnums()
        }
    }, []);
   
    useEffect(() => {
        if(enums?.service_types){
            const sub_types = helpers.filterObject(enums.service_types, form_data.service_type_id)

            setSubTypes(sub_types?.sub_service_types)
        }
    }, [form_data.service_type_id, enums]);
    
    useEffect(() => {
        if(form_data.status == 1){
            setButtonItems([{
                label: 'Save and Confirm',
                icon: 'pi pi-refresh',
                command: (e) => {
                    submit(e.originalEvent, 2)
                }
            }])
        }
        else{
            setButtonItems([{
                label: 'Draft',
                icon: 'pi pi-refresh',
                command: (e) => {
                    submit(e.originalEvent, 1)
                }
            }])
        }
    }, [form_data, record_items]);
    
    useEffect(() => {
        displayTableItems()
    }, [
        record_items,
    ]);

    function displayTableItems(){
        let items = []
        
        if (record_items?.length) {
            items = Object.entries(record_items).map(([key, data]) => {
                return(
                    <tr>
                        <td>{data.qr_code ? data.qr_code : '---'}</td>
                        <td>{data.brand}</td>
                        <td>{data.serial_no ? data.serial_no : '---'}</td>
                        <td>{data.order_no ? data.order_no : '---'}</td>
                        <td>{data.unit_location ? data.unit_location : '---'}</td>
                        <td>
                            <InputTextarea
                                name="complaint" 
                                value={data.complaint}  
                                className="w-100 mt-2 p-1"
                                maxLength={1500}
                                onChange={(e) => inputItemChange(e, key)}
                                placeholder="Describe unit problem"
                            />
                        </td>
                        <td width={100} style={{paddingRight: '.75rem'}}>
                            <ButtonGroup aria-label="Basic example" size="sm">
                                <Button variant="info" onClick={() => updateItem(data)}><i className="fas fa-pencil-alt"></i></Button>
                                <Button variant="danger" onClick={(e) => removeItem(key)}><i className="fas fa-times"></i></Button>
                            </ButtonGroup>
                        </td>
                    </tr>
                )
            })
        }

        setTableItems(items)
    }
    
    function inputItemChange(e, key) {
        let { value, name } = e.target;
        let items = [...record_items]
        let target = {...items[key]}

        if(name === 'quantity'){
            const available_stock = target['available_stock']

            if(target.tax_rate){
                
                const tax_amount = (parseFloat(target.tax_rate) / 100) * (parseInt(value) * parseFloat(target.amount))

                target.tax_amount = tax_amount
            }

            if(parseInt(value) > parseInt(available_stock)){
                return;
            }
        }
        else if(name === 'tax_rate'){
            name = 'tax_rate_id'
            const tax = helpers.filterObject(enums.tax_rates, value) ?? [];
            
            if ( tax.hasOwnProperty('id') ) {
                target.tax_name = tax.tax_name
                target.tax_rate = tax.tax_rate

                const tax_amount = (parseFloat(tax.tax_rate) / 100) * (parseFloat(target.amount) * parseFloat(target.quantity))

                if(!isNaN(tax_amount)){
                    target.tax_amount = tax_amount;
                }
            }
            else{
                target.tax_name = ''
                target.tax_rate = ''
                target.tax_amount = 0;
            }
        }
        else if(name === 'amount'){
            if(target.tax_rate){
                //const tax_amount = (parseFloat(target.tax_rate) / 100) * parseFloat(value)
                const tax_amount = (parseFloat(target.tax_rate) / 100) * (parseFloat(value) * parseFloat(target.quantity))

                target.tax_amount = tax_amount
            }
        }

        target[name] = value
        items[key] = target

        setRecordItems(items)
    }

    function updateItem(e){
        setProductUnitID(e.id)
        setProductUnitFormModal(1)
    }

    function removeItem(key){
        let items = [...record_items]
        items.splice(key, 1); 

        setRecordItems(items)
    }


    const fetchEnums = async () => {
        setLoading(true)
        const res = await getServiceHubEnums()
        if(res.status === 'success'){
            setEnums(res.data)
            setLoading(0)
        }
    }

    async function fetchData(id){
        setLoading(1)
        if(!id){
            return
        }

        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/${id}`)
        const res = await getApiData(endpoint, false)

        if(res){
            setLoading(0)
            //res.purchased_date = new Date(res.purchased_date)
            setFormData(res)
            fetchEnums()
            setRecordItems(res.items)

            let btn_item = []
            if(res.status === 1){
                btn_item.push({
                    label: 'Save and Confirm',
                    icon: 'pi pi-refresh',
                    command: (e) => {
                        submit(e.originalEvent, 2)
                    }
                })
            }
            else if(res.status === 2){
                btn_item.push({
                    label: 'Set as Open',
                    icon: 'pi pi-refresh',
                    command: (e) => {
                        submit(e.originalEvent, 1)
                    }
                })
            }

            setButtonItems(btn_item)
        }
        
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/service-requests/list");
                }
            })
        }
    }
    async function fetchProductUnit(id){
        setLoading(1)
        if(!id){
            return
        }

        let endpoint = helpers.createServiceHubUrl(`v1/product-details/${id}`)
        const res = await getApiData(endpoint, false)

        if(res){
            setLoading(0)
            let data = {...form_data}
            data.customer_id = res.customer_id ?? ''
            data.customer_name = res.customer_name ?? ''
            //data.phone_no = e.phone_no ?? ''
            //data.email = e.email ?? ''
            setFormData(data)
            handleProductUnit(res)
            fetchEnums()
        }
        
        if(res.status === 'error'){
            setLoading(0)
            Swal.fire({
                text: res.message,
                icon: "error",
                confirmButtonText: "OK",
                allowOutsideClick: false
            })
            .then((result) => {
                if (result.isConfirmed) {
                    window.location.replace("/service-requests/list");
                }
            })
        }
    }

    async function submit(e, status = ''){
        //e.preventDefault()

        form_data.items = record_items
        form_data.status = status
        
        let endpoint = helpers.createServiceHubUrl(`v1/service-requests/create`)
        if(service_request_id){
            endpoint = helpers.createServiceHubUrl(`v1/service-requests/${service_request_id}`)
        }
        const res = await postApiData(endpoint, form_data)

        setLoading(0)
        if(res.status === 'error'){
            if(res.data){
                setErrors( res.data );
            }else{
                setErrors([])
            }
            return
        }

        let id = service_request_id;
        if(!id){
            id = res.data.id
        }

        Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            confirmButtonText: "OK",
        })
        .then((result) => {
            if (result.isConfirmed && !service_request_id) {;
                window.location.replace(`/service-requests/${id}/form`);
                return;
            }
            else{
                fetchData(id)
            }
        })
    }
    
    function inputChange(e) {
        let { name, value } = e.target;

        if (e.target.type === "checkbox") {
            if (e.target.checked) {
                value = 1;

                if(name == 'warranty_status') value = 'active'
            } else {
                value = 0;

                if(name == 'warranty_status') value = 'expired'
            }
        }
        else if (e.target.type === "file") {
          value = e.target.files[0]
        }

        let new_state = { [name]: value }

        if(name == 'invoice_no'){
            new_state.invoice_id = ''
        }
        if(name == 'service_type_id'){
            new_state.sub_service_type_id = ""
        }

        //helpers.updateFormKeys(setFormData, new_state)
        setFormData({ ...form_data, ...new_state });
    }

    function handleCustomer(e){
        let data = {...form_data}
        data.customer_id = e.id ?? ''
        data.customer_name = e.contact_name ?? ''
        data.phone_no = e.phone_no ?? ''
        data.email = e.email ?? ''
        setFormData(data)
    }

    function handleProductUnit(e){
        setRecordItems(prevItems => {
            const index = helpers.isObjectExistIndex(prevItems, e.id);

            if (index !== null) {
                const existing = prevItems[index];
                const updatedItem = {
                    ...existing,
                    ...e,
                    complaint: existing.complaint ?? ''
                };
                return helpers.updateItemInState(prevItems, updatedItem);
            }

            const newItem = { ...e, complaint: '' };
            return [...prevItems, newItem];
        });
    }

    function handleSelectedProductUnit(e){
        setRecordItems(prevItems => {
            const index = helpers.isObjectExistIndex(prevItems, e.id);

            if (index !== null) {
                const existing = prevItems[index];
                const updatedItem = {
                    ...existing,
                    ...e,
                    complaint: existing.complaint ?? ''
                };
                return helpers.updateItemInState(prevItems, updatedItem);
            }

            const newItem = { ...e, complaint: '' };
            return [...prevItems, newItem];
        });
    }

    return (
        <div>
            <ContactListModal is_show={customer_modal} setShow={setContactModal} handleSelect={handleCustomer} />

            <ProductUnitFormModal
                is_show={product_unit_form_modal}
                setShow={setProductUnitFormModal} 
                handleSave={handleProductUnit} 
                ref_id={product_unit_id}
                customer_id={form_data.customer_id}
            />

            <ProductUnitListModal
                is_show={product_unit_list_modal}  
                setShow={setProductUnitListModal} 
                handleSelect={handleSelectedProductUnit} 
                exclude={record_items}
                customer_id={form_data.customer_id}
            />

            <Layout page_title={page_title} menu="manage-service-requests" breadcrumbs={true} parent_link='/service-requests/list' parent_text="PolarCare">
                    <div className="content">
                        <div className="container-fluid pb-5" style={{position: 'relative'}}>
                            <Loader isLoading={loading}/>
                            <form onSubmit={submit}>
                                <div className="row mb-2">
                                    <div id="so-customer-section" className="col-lg-12">
                                    
                                        {form_data.service_no ?
                                        <div className='border rounded p-3 mb-3 d-flex flex-column flex-md-row justify-content-between align-items-center'>
                                            <h5 className='mb-3 mb-md-0 d-flex'>Service No: {form_data.service_no}
                                                &nbsp;&nbsp;&nbsp;{helpers.displayServiceRequestStatusBadge(form_data.status, form_data.status_name)}
                                            </h5>
                                            <div className='d-flex flex-column flex-sm-row'>
                                            </div>
    
                                            <div className='text-right'>     
                                                {
                                                    parseInt(form_data.status) != 8 && parseInt(form_data.status) !== 9 && parseInt(form_data.status) !== 10 ?
                                                    <SplitButton 
                                                        label="Save" 
                                                        buttonClassName="rounded-left border-right" 
                                                        onClick={(e) => submit(e, 2)} 
                                                        model={button_items} 
                                                        severity={"success"} 
                                                    /> : ''
                                                }
    
                                                {/* <Link className='btn btn-outline-dark ml-3' to={`/sales/${service_request_id}`} style={{padding: '0.5rem 0.75rem'}}>Cancel</Link>   */}
                                                {/* {
                                                    service_request_id ? 
                                                    <Link className='btn btn-outline-dark ml-3' to={`/sales/${service_request_id}`} style={{padding: '0.5rem 0.75rem'}}>Cancel</Link>   : 
                                                    <Link className='btn btn-outline-dark ml-3' to="/sales/list" style={{padding: '0.5rem 0.75rem'}}>Cancel</Link>
                                                } */}
                                                <Link className='btn btn-outline-dark ml-3' to="/service-requests/list" style={{padding: '0.5rem 0.75rem'}}>Cancel</Link>
                                            </div>
                                        </div> : ''}

                                        <div className="card">
                                            <div className="card-body pt-md-5">
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>Service Type<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <div>
                                                        <Dropdown  
                                                            ref={dropdownRef}
                                                            name='service_type_id'
                                                            value={form_data.service_type_id} 
                                                            onChange={inputChange} 
                                                            options={enums.service_types} 
                                                            optionLabel="service_type_name" 
                                                            optionValue="id" 
                                                            placeholder="Select Service Type" 
                                                            className="w-100" 
                                                            checkmark={true} 
                                                            highlightOnSelect={false}
                                                            showClear
                                                            filter 
                                                        />
                                                        </div>
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="service_type_id" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>

                                                {
                                                    sub_service_types?.length ?
                                                    <div className="row">
                                                        <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                            <label>Sub Service Type<span className="text-danger">*</span></label>
                                                        </div>
                                                        <div className="col-md-5 col-lg-3 form-group">
                                                            <div>
                                                            <Dropdown  
                                                                ref={dropdownRef}
                                                                name='sub_service_type_id'
                                                                value={form_data.sub_service_type_id} 
                                                                onChange={inputChange} 
                                                                options={sub_service_types} 
                                                                optionLabel="service_type_name" 
                                                                optionValue="id" 
                                                                placeholder="Select Sub Service Type" 
                                                                className="w-100" 
                                                                checkmark={true} 
                                                                highlightOnSelect={false}
                                                                showClear
                                                                filter 
                                                                
                                                            />
                                                            </div>
                                                            <RenderErrors 
                                                                errors={errors} 
                                                                name="sub_service_type_id" 
                                                                className="text-danger"
                                                                style={{fontSize: '.9rem'}}
                                                            />
                                                        </div>
                                                    </div> : ""
                                                }
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>Customer<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <div className="input-group">
                                                            {
                                                                service_request_id ? <input type="text" className="form-control" placeholder="Select Customer" disabled={service_request_id}  value={form_data.customer_name}  /> : <input type="text" className="form-control" placeholder="Select Customer" onClick={(e) => setContactModal(1)} value={form_data.customer_name} />
                                                            }

                                                            <div className="input-group-append">
                                                                <button className="btn btn-primary" type="button" onClick={(e) => setContactModal(1)} disabled={service_request_id}><i className="fas fa-search" /></button>
                                                            </div>
                                                        </div>
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="customer_name" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>Phone No<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <InputMask 
                                                            id="phone_no" 
                                                            name="phone_no" 
                                                            mask="9999-999-9999" 
                                                            value={form_data.phone_no}
                                                            placeholder="0920-321-5468"
                                                            onChange={inputChange}
                                                            className='w-100'
                                                         />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="phone_no" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>Email<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <InputText
                                                            id="email" 
                                                            name="email" 
                                                            value={form_data.email}
                                                            placeholder="Email"
                                                            onChange={inputChange}
                                                            type="email"
                                                            keyfilter="email"
                                                            className='w-100'
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="email" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>Address 1<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <InputText
                                                            id="address_1" 
                                                            name="address_1" 
                                                            value={form_data.address_1}
                                                            onChange={inputChange}
                                                            placeholder="Apartment/House No"
                                                            className='w-100'
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="address_1" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>Address 2</label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <InputText
                                                            id="address_2" 
                                                            name="address_2" 
                                                            value={form_data.address_2}
                                                            onChange={inputChange}
                                                            placeholder="Street No/Barangay/District"
                                                            className='w-100'
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="address_2" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>City<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <InputText
                                                            id="city" 
                                                            name="city" 
                                                            value={form_data.city}
                                                            onChange={inputChange}
                                                            placeholder="City"
                                                            className='w-100'
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="city" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label>Province<span className="text-danger">*</span></label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <InputText
                                                            id="province" 
                                                            name="province" 
                                                            value={form_data.province}
                                                            onChange={inputChange}
                                                            placeholder="Province"
                                                            className='w-100'
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="province" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-md-3 col-lg-3 text-left text-md-right">
                                                        <label className='mb-0'>Remarks</label>
                                                    </div>
                                                    <div className="col-md-5 col-lg-3 form-group">
                                                        <InputTextarea
                                                            id="remarks" 
                                                            name="remarks" 
                                                            value={form_data.remarks}  
                                                            className='w-100'
                                                            onChange={inputChange}
                                                            placeholder=""
                                                            rows={3}
                                                            
                                                        />
                                                        <RenderErrors 
                                                            errors={errors} 
                                                            name="remarks" 
                                                            className="text-danger"
                                                            style={{fontSize: '.9rem'}}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                

                                <div invoice_id="so-item-container mt-5" className="row">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body p-0 table-responsive">
                                                <table className='table mb-0'>
                                                    <thead className='thead-light'>
                                                        <tr>
                                                            <th>QR CODE</th>
                                                            <th>BRAND</th>
                                                            <th>SERIAL NO</th>
                                                            <th>REFERENCE NO</th>
                                                            <th>UNIT LOCATION</th>
                                                            <th>COMPLAINT</th>
                                                            <th>ACTION</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {table_items}
                                                        {form_data.status != 5 && form_data.status != 6 && form_data.status != 7 && form_data.status != 8 ?
                                                        <tr className='bg-light'>
                                                            <td colSpan={7} className='text-center'>
                                                                <RenderErrors 
                                                                    errors={errors} 
                                                                    name="items" 
                                                                    className="text-danger mb-2"
                                                                    style={{fontSize: '.9rem'}}
                                                                />
                                                                <ButtonGroup aria-label="Basic example">
                                                                    <Button variant="outline-primary" onClick={(e) => setProductUnitListModal(1)}><i className="fas fa-search" /> Search Existing</Button>
                                                                    <Button 
                                                                    variant="outline-primary" 
                                                                    onClick={(e) => {
                                                                        setProductUnitID('')
                                                                        setProductUnitFormModal(1)
                                                                    }}><i className="fas fa-plus-circle" /> New Item</Button>
                                                                </ButtonGroup>
                                                            </td>
                                                        </tr> : ''}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='text-right mt-3'>
                                    {/* <button type='button' className='btn btn-success ml-3' onClick={(e) => submit(e, 2)}>Publish</button>
                                    <Link className='btn btn-outline-dark ml-3' to={'/service-requests/list'}>Cancel</Link> */}

                                    {
                                        parseInt(form_data.status) != 8 && parseInt(form_data.status) !== 9 && parseInt(form_data.status) !== 10 ?
                                        <SplitButton 
                                            label="Save" 
                                            buttonClassName="rounded-left border-right" 
                                            onClick={(e) => submit(e, form_data.status)} 
                                            model={button_items} 
                                            severity={"success"} 
                                        /> : ''
                                    }
                                    
                                    {/* {
                                        service_request_id ? 
                                        <Link className='btn btn-outline-dark ml-3' to={`/service-requests/${service_request_id}`} style={{padding: '0.5rem 0.75rem'}}>Cancel</Link>   : 
                                        <Link className='btn btn-outline-dark ml-3' to="/service-requests/list" style={{padding: '0.5rem 0.75rem'}}>Cancel</Link>
                                    } */}
                                        <Link className='btn btn-outline-dark ml-3' to="/service-requests/list" style={{padding: '0.5rem 0.75rem'}}>Cancel</Link>
                                </div>
                            </form>
                        </div>
                    </div>
            </Layout>
        </div>
    )
}